import { useEffect } from "react";

const GroundOverlay = ({ map, url, bounds, opacity = 0.5 }) => {
  useEffect(() => {
    if (!map || !window.google) return;

    const overlay = new window.google.maps.GroundOverlay(
      url,
      {
        north: bounds.north,
        south: bounds.south,
        east: bounds.east,
        west: bounds.west,
      },
      { opacity }
    );

    overlay.setMap(map);

    return () => {
      overlay.setMap(null); // Clean up on unmount
    };
  }, [map, url, bounds, opacity]);

  return null;
};

export default GroundOverlay;
